/**
 * Slugify a string
 * @param name - The string to slugify
 * @returns The slugified string
 */
export const slugify = (name: string): string => {
  return name
    ?.toLowerCase()
    .trim()
    .replace(/\s+/g, '_') // Replace spaces with _
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-/g, '_') // Replace - with _
    .replace(/\_\_+/g, '_'); // Replace multiple _ with _
};

/**
 * Slugify a string with hyphens
 * @param name - The string to slugify
 * @returns The slugified string
 */
export const slugifyHyphen = (name: string): string => {
  return name
    ?.toLowerCase()
    .trim()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\_/g, '-') // Replace _ with -
    .replace(/\-\-+/g, '-'); // Replace multiple - with -
};
